import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';

const Pagination = ({ query, numberOfPage, setQuery }) => {
  const history = useHistory();
  const location = useLocation();

  const newPage = (page) => {
    if (location.pathname.includes('/contract') && setQuery) {
      return setQuery({ ...query, page: page });
    }
    history.push({ search: '?' + new URLSearchParams({ ...query, page: page + 1 }) });
  };

  return (
    <nav aria-label="...">
      <ul className="pagination">
        <li className={query.page === 0 ? 'page-item disabled' : 'page-item pointer'}>
          <div
            className="page-link"
            tabIndex="-1"
            onClick={() => {
              newPage(query.page - 1);
            }}
          >
            {'<'}
          </div>
        </li>
        <li className="page-item">
          <div className="page-link">
            {query.page + 1} of {numberOfPage}
          </div>
        </li>
        <li className={query.page + 1 === numberOfPage ? 'page-item disabled' : 'page-item pointer'}>
          <div
            className="page-link"
            onClick={() => {
              newPage(query.page + 1);
            }}
          >
            {'>'}
          </div>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
